export default "__VITE_ASSET__C08QrWYz__"